// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1kRJq","row":"Node_row__61ssg","label":"Node_label__1r3Z7","footer":"Node_footer__1e2oX"};